<template>
  <div>
    <el-dialog
        title="指定司机信息"
        :lock-scroll="true"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        width="700px"
    >
      <section class="dialogContent">
        <TableBox ref="tableBox" @closeModal="dialogFormVisible=false"/>
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="cancle">关闭</el-button>
        <!--        <el-button type="primary" @click="choose" :loading="subLoading"-->
        <!--        >确定</el-button-->
        <!--        >-->
      </section>
    </el-dialog>
  </div>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBox from './tableBox';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBox,
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false,
    };
  },
  methods: {
    show (id) {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.tableBox.saveSearchBoxData({sourceId: id});
      });
    },
    cancle () {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
//.dialogContent {
//  padding-bottom: 24px;
//}
</style>
